import { RestBase } from './base'

export class RestPlayer {
  private rest: RestBase

  constructor() {
    this.rest = new RestBase()
  }

  public status(partyId: number): Promise<void> {
    return this.rest.get(`/api/parties/${partyId}/player/status`)
  }
}
